const clearData = (db) => {
  // open a read/write db transaction, ready for clearing the data
  const transaction = db?.transaction(['IdentityIds'], 'readwrite');

  // create an object store on the transaction
  const objectStore = transaction.objectStore('IdentityIds');

  // Make a request to clear all the data out of the object store
  objectStore.clear();
};

const clearLocalIndexedDb = async () => {
  try {
  // Let us open our database
    const DBOpenRequest = window?.indexedDB?.open('aws:cognito-identity-ids');

    if (DBOpenRequest) {
      DBOpenRequest.onsuccess = () => {
      // store the result of opening the database in the db variable.
      // This is used a lot below
        const db = DBOpenRequest.result;
        // Clear all the data from the object store
        if (db) {
          clearData(db);
        }
      };
    }
    localStorage.clear();
  } catch {
    // nothing to do
  }
};

export default clearLocalIndexedDb;
